import { ReactNode } from "react"

import * as Portal from "@radix-ui/react-portal"

export const Fullscreen = ({
  children,
  enabled,
}: {
  children: ReactNode
  enabled?: boolean
}) => {
  if (!enabled) return children
  return (
    <Portal.Root className="pointer-events-auto fixed top-0 left-0 z-[9999] h-screen w-screen bg-white">
      {children}
    </Portal.Root>
  )
}
